export function validateTradeLink(link: string): string | null {
  if (!link.startsWith("https://steamcommunity.com/tradeoffer/new/")) {
    return "Trade link must start with the correct Steam URL";
  }

  try {
    const url = new URL(link);
    const partner = url.searchParams.get("partner");
    const token = url.searchParams.get("token");

    if (!partner || !token) {
      return "Trade link must contain both 'partner' and 'token' parameters";
    }

    if (!/^\d+$/.test(partner)) {
      return "Invalid partner ID in trade link";
    }

    return null; // no error
  } catch (err) {
    return "Invalid URL format";
  }
}
